import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Moment from 'moment'

const Item = (props) => {
  if (props.indexKey >= (props.currentPage - 1) * 10 && props.indexKey < props.currentPage * 10) {
    return (<tr>
      <td> {(parseInt(props.skip, 0) + props.indexKey + 1) - ((props.currentPage - 1) * 10)} </td>
      <td>
        <Link to={`/projects/${props.row.id}`}>
          {
            props.row.name
              ? props.row.name
              : 'No Project Name'
          }
        </Link>
      </td>
      <td>
        <span>
          {`${props.taskStatus[props.indexKey].taskCompleted} / ${props.taskStatus[props.indexKey].allTask}`}
        </span>
      </td>
      <td>
        <span>
          {
            props.row.profile.name
              ? props.row.profile.name
              : 'No Client Workspace'
          }
        </span>
      </td>
      <td>
        <span>
          {
            props.row.service.name
              ? props.row.service.name
              : 'No Project Type'
          }
        </span>
      </td>
      <td>
        <span>
          {
            props.row.country.name
              ? props.row.country.name
              : 'No Country'
          }
        </span>
      </td>
      <td>
        {
          props.row.endDate
            ? Moment(`${props.row.endDate}`).format('DD MMMM YYYY')
            : '-'
        }
      </td>
    </tr>)
  }
  return (<tr>{}</tr>)
}

Item.defaultProps = {
  row: {
    id: '',
    endDate: '',
    name: '',
    country: {
      name: '',
    },
    profile: {
      name: '',
    },
    service: {
      name: '',
    },
  },
  skip: 0,
  indexKey: 0,
}

Item.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    name: PropTypes.string,
    country: PropTypes.shape({
      name: PropTypes.string,
    }),
    profile: PropTypes.shape({
      name: PropTypes.string,
    }),
    service: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  currentPage: PropTypes.number.isRequired,
  taskStatus: PropTypes.arrayOf(PropTypes.object).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
